import React from 'react';
import ServerPaginatedTable from '../utils/pagination.server';
import ViewIcon from 'react-icons/lib/md/remove-red-eye';
import ToolTipItem from "../utils/tooltip";
import PageEmptyContent from "../utils/page.empty-content";
import { appHelpers } from '../../_helpers';
import {Badge} from "reactstrap";


const DataTable = ({data, handApprovalModal }) =>{
    return (data.length === 0) ?
        (<PageEmptyContent message='No record match your search!'/>) :
        (
            <div className="view">
                <div className="table-responsive">
                    <table className="table table-striped table-hover">
                        <thead>
                        <tr>
                            <th>
                                <span>Entity</span>
                            </th>
                            <th >
                                <span>Created By</span>
                            </th>
                            <th>
                                <span>Created Date</span>
                            </th>
                            <th>
                                <span>Approved By</span>
                            </th>
                            <th>
                                <span>Status</span>
                            </th>
                            <th>
                                <span>Action</span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {data.map((record, i) =>
                            <tr key={i+1}>
                                <td
                                    className="text-capitalize">{appHelpers.interpretEntityTypeId(record.EntityTypeId)}</td>
                                <td>{record.CreatedBy}</td>
                                <td>{appHelpers.formatDateSpecific(record.CreatedDate)}</td>
                                <td>{record.ApprovedBy}</td>
                                <td>
                                    {record.StatusId === 0 &&
                                        <Badge color={"secondary"}>&nbsp;Pending&nbsp;</Badge>
                                    }
                                    {record.StatusId === 1 &&
                                        <Badge color='success'>&nbsp;Approved&nbsp;</Badge>
                                    }
                                    {record.StatusId === 2 &&
                                        <Badge color='warning'>&nbsp;Rejected&nbsp;</Badge>
                                    }
                                </td>
                                <td>
                                    <span className="pointer" onClick={() => handApprovalModal(record)}>
                                        <ToolTipItem key={'viewRecord'} title={<ViewIcon size="18" color="#3da7e2"/>} content='View' id={'viewRecord'}/>
                                    </span>
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
        )
}

class PaginatedResult extends React.Component {

    render() {
        const {  pageSize, currentPage, totalCount,navigate, records, handApprovalModal} = this.props;
        return (
            <div>
                <div className="row">
                    <div className="col-md-12 col-sm-12 mb-4" >
                        <ServerPaginatedTable  currentPage={currentPage} fetchMore={navigate} target={<DataTable data={records} handApprovalModal={handApprovalModal} />} pageSize={pageSize} totalCount={totalCount }/>
                    </div>
                </div>
            </div>
        );
    }
}

export default PaginatedResult



// WEBPACK FOOTER //
// ./src/views/makerChecker/records.js